import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const requestsService = {
  getFormData: async (formObject) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/getFormData`,
        formObject
      );
      const response1 = response?.data?.formData?.app_form.map(attr => ({
        ...attr,
        attribute_display_value: attr.attribute_display_value,
        
        attribute_help_text_display_value: attr.attribute_help_text_display_value
          ? attr.attribute_help_text_display_value.replace(/(\r\n|\n|\r|\\n)/g, "<br>")
          : attr.attribute_help_text_display_value
      }));
      
      response.data.formData.app_form = response1;
      console.log('first',response.data);
      
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  getModifiedFormData: async (formObject) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/getModifyFormData`,
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  getDisableFormData: async (formObject) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/getDisableFormData`,
        formObject
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching form data:", error);
      throw error; // Re-throw to handle in components
    }
  },

  getAppList: async (appFilter,gpid) => {
    try {
      
      const response = await axios.post(`${API_ENDPOINT}arfw/getAppList`, {
        appFilter,
        'fetchApproversData' : false,
        'ignorePagination':true,
        'gpid':gpid
      });
      if(response?.data?.totalCount == 0){
        return [];
      }
      if (response?.data?.appFormList?.length === 0) {
          return [];
        // Return a default list if no data is found
        // return [
        //   { label: "Spaceman", id: "Spaceman", isBadge: false },
        //   { label: "Celonis", id: "Celonis", isBadge: false },
        //   {
        //     label: "PBC - Enterprise Settlement Console",
        //     id: "PBC - Enterprise Settlement Console",
        //     isBadge: false,
        //   },
        //   { label: "Mosaic TM1", id: "Mosaic TM1", isBadge: false },
        // ];
      }

      // Transform response data
      return response.data.appFormList.map((item) => ({
        label: item.appName,
        id: item.appFormId,
        desc: item.appDescription,
        isBadge: false,
        newApproverLevels: item.newApproverLevels,
        myidm: item.pepAppEnabledForIAMCentral,
        currentAccessApp:item.currentAccessApp,
        modifyDisableRequestInProgress:item.modifyDisableRequestInProgress,
        newRequestInProgress:item.newRequestInProgress,
        pepAppViewType:item.pepAppViewType,
      }));
    } catch (error) {
      console.error("Error fetching app list:", error);
      throw error; // Re-throw for handling in components
    }
  },

  getCurrentAccessAppList: async (appFilter) => {
    try {
      const response = await axios.post(`${API_ENDPOINT}arfw/getUserCurrentAccess`, {
        'uid':appFilter,
        'fetchApproversData' : false,
        'fetchAllApps':true
      });

      // Transform response data
      return response.data.appFormList.map((item) => ({
        label: item.appName,
        desc: item.appDescription,
        id: item.appFormId,
        isBadge: false,
        newApproverLevels: item.newApproverLevels,
        myidm: item.pepAppEnabledForIAMCentral,
        modifyDisableRequestInProgress:item.modifyDisableRequestInProgress,
        newRequestInProgress:item.newRequestInProgress,
        pepAppViewType:item.pepAppViewType,
      }));
    } catch (error) {
      console.error("Error fetching current access app list:", error);
      throw error; // Re-throw for handling in components
    }
  },

  getRolesList: async () => {
    try {
      const response = await axios.get(`${API_ENDPOINT}arfw/getAllRoles`);
      // Transform response data
      console.log('222222222222222222',response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching current access app list:", error);
      throw error; // Re-throw for handling in components
    }
  },

  getRoleAppList: async (jsonData) => {
    try {
      jsonData.fetchApproversData = false;
      const response = await axios.post(
        `${API_ENDPOINT}arfw/searchApps`,
        jsonData,
        
      );
      return response.data.appFormList.map((item) => ({
        label: item.appName,
        id: item.appFormId,
        desc: item.appDescription,
        isBadge: false,
        newApproverLevels: item.newApproverLevels
      }));
    } catch (error) {
      console.error("Error submitting form:", error);
      throw error;
    }
  },

  submitFormRequest: async (jsonData) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/submitFormRequest`,
        jsonData
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      throw error;
    }
  },

  submitModifiedFormRequest: async (jsonData) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/submitModifyForm`,
        jsonData
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      throw error;
    }
  },
  submitDisableFormRequest: async (jsonData) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}arfw/submitDisableForm`,
        jsonData
      );
      return response.data;
    } catch (error) {
      console.error("Error submitting form:", error);
      throw error;
    }
  },
};

export default requestsService;
